// 部门管理
const workAttendanceDepartmentServiceJurisdiction = [
  { id: "034002001", label: "添加", children: [] },
  { id: "034002002", label: "修改", children: [] },
  { id: "034002003", label: "删除", children: [] }
];

// 岗位管理
const workAttendancePositionServiceJurisdiction = [
  { id: "034003001", label: "添加", children: [] },
  { id: "034003002", label: "修改", children: [] },
  { id: "034003003", label: "删除", children: [] }
];

// 人员管理
const workAttendancePersonServiceJurisdiction = [
  { id: "034004001", label: "添加", children: [] },
  { id: "034004002", label: "修改", children: [] },
  { id: "034004003", label: "删除", children: [] }
];

// 加班配置
const workAttendanceOvertimeServiceJurisdiction = [
  { id: "034005001", label: "添加", children: [] },
  { id: "034005002", label: "修改", children: [] },
  { id: "034005003", label: "删除", children: [] }
];

// 考勤点管理
const workAttendancePointServiceJurisdiction = [
  { id: "034006001", label: "添加", children: [] },
  { id: "034006002", label: "修改", children: [] },
  { id: "034006003", label: "删除", children: [] }
];

// 班组管理
const workAttendanceTeamServiceJurisdiction = [
  { id: "034007001", label: "添加", children: [] },
  { id: "034007002", label: "修改", children: [] },
  { id: "034007003", label: "删除", children: [] }
];

// 班次管理
const workAttendanceFrequencyServiceJurisdiction = [
  { id: "034008001", label: "添加", children: [] },
  { id: "034008002", label: "修改", children: [] },
  { id: "034008003", label: "删除", children: [] }
];

// 排班管理
const workAttendanceSchedulingServiceJurisdiction = [
  { id: "034009001", label: "添加", children: [] },
  { id: "034009002", label: "修改", children: [] },
  { id: "034009003", label: "删除", children: [] }
];

// 调班管理
const workAttendanceSwitchServiceJurisdiction = [
  { id: "034010001", label: "添加", children: [] },
  { id: "034010002", label: "修改", children: [] },
  { id: "034010003", label: "删除", children: [] }
];

// 加班申请
const workAttendanceOvertimeApplicationServiceJurisdiction = [
  { id: "034011001", label: "添加", children: [] },
  { id: "034011002", label: "修改", children: [] },
  { id: "034011003", label: "删除", children: [] },
  { id: "034013004", label: "提交审批", children: [] }
];

// 补卡申请
const workAttendanceRepairApplicationServiceJurisdiction = [
  { id: "034012001", label: "添加", children: [] },
  { id: "034012002", label: "修改", children: [] },
  { id: "034012003", label: "删除", children: [] },
  { id: "034013004", label: "提交审批", children: [] }
];

// 请假调休
const workAttendanceAdjustApplicationServiceJurisdiction = [
  { id: "034013001", label: "添加", children: [] },
  { id: "034013002", label: "修改", children: [] },
  { id: "034013003", label: "删除", children: [] },
  { id: "034013004", label: "提交审批", children: [] }
];

// 假期管理
const workAttendanceVacationApplicationServiceJurisdiction = [
  { id: "034014001", label: "添加", children: [] },
  { id: "034014002", label: "修改", children: [] },
  { id: "034014003", label: "删除", children: [] }
];

// 考勤报表
const workAttendanceSalaryReportServiceJurisdiction = [
  { id: "034018001", label: "手动生成报表", children: [] }
]

// 薪酬报表
const workAttendanceReportServiceJurisdiction = [
  { id: "034016001", label: "手动生成报表", children: [] }
]

// 考勤配置
const workAttendanceConfigServiceJurisdiction = [
  { id: "034020001", label: "修改配置", children: [] }
]

// 智慧考勤
const workAttendanceServiceJurisdictionChildren = [
  {
    id: "034002000",
    label: "部门管理",
    routerName: "attendance-department-manage",
    children: workAttendanceDepartmentServiceJurisdiction
  },
  {
    id: "034003000",
    label: "岗位管理",
    routerName: "attendance-position-manage",
    children: workAttendancePositionServiceJurisdiction
  },
  {
    id: "034004000",
    label: "人员管理",
    routerName: "attendance-person-manage",
    children: workAttendancePersonServiceJurisdiction
  },
  {
    id: "034005000",
    label: "加班配置",
    routerName: "attendance-overtime-manage",
    children: workAttendanceOvertimeServiceJurisdiction
  },
  {
    id: "034006000",
    label: "考勤点管理",
    routerName: "attendance-point-manage",
    children: workAttendancePointServiceJurisdiction
  },
  {
    id: "034007000",
    label: "班组管理",
    routerName: "attendance-team-manage",
    children: workAttendanceTeamServiceJurisdiction
  },
  {
    id: "034008000",
    label: "班次管理",
    routerName: "attendance-frequency-manage",
    children: workAttendanceFrequencyServiceJurisdiction
  },
  {
    id: "034009000",
    label: "排班管理",
    routerName: "attendance-scheduling-manage",
    children: workAttendanceSchedulingServiceJurisdiction
  },
  {
    id: "034010000",
    label: "调班管理",
    routerName: "attendance-switch-manage",
    children: workAttendanceSwitchServiceJurisdiction
  },
  {
    id: "034011000",
    label: "加班申请",
    routerName: "attendance-overtime-application-manage",
    children: workAttendanceOvertimeApplicationServiceJurisdiction
  },
  {
    id: "034012000",
    label: "补卡申请",
    routerName: "attendance-repair-application-manage",
    children: workAttendanceRepairApplicationServiceJurisdiction
  },
  {
    id: "034013000",
    label: "请假调休",
    routerName: "attendance-adjust-manage",
    children: workAttendanceAdjustApplicationServiceJurisdiction
  },
  {
    id: "034014000",
    label: "假期管理",
    routerName: "attendance-vacation-manage",
    children: workAttendanceVacationApplicationServiceJurisdiction
  },
  {
    id: "034019000",
    label: "打卡记录",
    routerName: "attendance-punch-record-manage",
    children: []
  },
  {
    id: "034015000",
    label: "考勤记录",
    routerName: "attendance-record-manage",
    children: []
  },
  {
    id: "034018000",
    label: "考勤报表",
    routerName: "attendance-salary-report",
    children: workAttendanceSalaryReportServiceJurisdiction
  },
  {
    id: "034016000",
    label: "薪酬报表",
    routerName: "attendance-report-manage",
    children: workAttendanceReportServiceJurisdiction
  },
  {
    id: "034020000",
    label: "考勤配置",
    routerName: "attendance-config",
    children: workAttendanceConfigServiceJurisdiction
  },
  {
    id: "034017000",
    label: "操作日志",
    routerName: "work-attendance-log",
    children: []
  }
];

const workAttendanceServiceJurisdiction = {
  id: "034",
  label: "智慧考勤",
  routerName: "",
  children: workAttendanceServiceJurisdictionChildren
};

export { workAttendanceServiceJurisdiction };



// WEBPACK FOOTER //
// ./src/utils/jurisdiction/WorkAttendanceJurisdiction.js